import React, { memo, useMemo } from 'react';
import { useLocation } from 'react-router';
import clsx from 'clsx';

import SecurityPageFooter from './SecurityPageFooter';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import SecurityPageHeader from './SecurityPageHeader';

import './SecurityPageWrapper.scss';

const SecurityPageWrapper = ({ children, backgroundStyle }) => {
  const { pathname } = useLocation();

  const mapLoginBackgrounds = useMemo(
    () => ({
      '/login': 'login',
      '/forgot-password': 'login',
      '/otp': 'otp',
      '/change-password': 'change-password',
      '/email-sent': 'email-sent',
    }),
    [],
  );

  const selectedBackground = useMemo(
    () =>
      backgroundStyle
        ? `security-page_logo_wrapper--${backgroundStyle}`
        : `security-page_logo_wrapper--${mapLoginBackgrounds[pathname]}`,
    [pathname, backgroundStyle, mapLoginBackgrounds],
  );

  return (
    <div className='security-page_wrapper'>
      <div className={clsx('security-page_logo_wrapper', selectedBackground)}>
        <Icon icon={ICONS.Logo} className='security-page_logo-size' disableCommonStyles />
        <Icon icon={ICONS.Factive} className='security-page_title-size' disableCommonStyles disableCommonColors />
      </div>

      <div className='security-page_content_wrapper'>
        <div className='security-page_content_header'>
          <SecurityPageHeader />
        </div>

        <div className='security-page_content'>{children}</div>

        <div className='security-page_content_footer'>
          <SecurityPageFooter />
        </div>
      </div>
    </div>
  );
};

export default memo(SecurityPageWrapper);
